module.exports = __webpack_public_path__ + "europa-20-paper.jpg?298e9f8d7f2ee43726fb9ee8d816053a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20-paper.jpg
// module id = 298
// module chunks = 0